import React from 'react';

import type { StatusActivityAction } from '@shared/patient-intake-status';

import type { TimelineItem } from '../HistoryDialog.types.ts';
import { NoteUpdateAction } from './NoteUpdateAction.tsx';
import { StepCreationAction } from './StepCreationAction.tsx';
import { StepDeletionAction } from './StepDeletionAction.tsx';
import { StatusUpdateAction } from './StatusUpdateAction.tsx';
import { ToggleDisabledAction } from './ToggleDisabledAction.tsx';

const throwNever = (value: never): never => {
  throw new Error(`Unexpected value: ${value}`);
};

type ActionSectionProps = {
  item: TimelineItem<StatusActivityAction>;
};

export const ActionSection: React.FC<ActionSectionProps> = ({ item }) => {
  const { action } = item;

  switch (action) {
    case 'UPDATE_STATUS':
      return <StatusUpdateAction item={item} />;

    case 'UPDATE_NOTE':
      return <NoteUpdateAction item={item} />;

    case 'CREATE_STEP':
      return <StepCreationAction item={item} />;

    case 'DELETE_STEP':
      return <StepDeletionAction item={item} />;

    case 'TOGGLE_DISABLED':
      return <ToggleDisabledAction item={item} />;

    default:
      return throwNever(action);
  }
};
